module.exports = __webpack_public_path__ + "static/media/no-invitation.9a1d3e38.png";